<template>
  <Navagation/>
  <div>
    <h4>Expenses</h4>
    <br>
    <div class="row">
      <table class="highlight centered">
        <thead>
          <tr>
            <th></th>
            <th>Asset</th>
            <th>Category</th>
            <th>Amount</th>
            <th>Description</th>
            <th>Date</th>
            <th>File</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expense in expenses" :key="expense.id">
            <td>
              <a class="btn-floating btn-large waves-effect waves-light red" :href="'/view?ID=' + expense.id">
                <i class="material-icons">search</i>
              </a>
            </td>
            <td> {{ expense.asset }} </td>
            <td> {{ expense.category }} </td>
            <td> {{ expense.amount }} </td>
            <td> {{ expense.description }} </td>
            <td> {{ expense.expense_date }} </td>
            <td> {{ expense.file }} </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Navagation from '@/components/Navagation.vue';
import axios from 'axios'

const API_ENDPOINT = 'https://8c8gylju3m.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage'

export default {
  name: 'App',
  components: { Navagation },

  data() {
    return {
      expenses: null
    }
  },

  mounted() {


    axios.get(API_ENDPOINT + "/expenses")
      .then(response => {
        this.expenses = response.data;
        console.log(response);
      });
  },

  getdata() {
    axios.get(API_ENDPOINT + "/expenses")
      .then(response => {
        this.expenses = response;
        console.log(response);
      });
  }





}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>